import * as React from 'react';
import Link from 'next/link';
import {
  Article,
  Figure,
  FigureLink,
  Summary,
  Category,
  CategoryLink,
  Alink,
  Heading,
  BlogInfo,
  Author,
  AuthorInfo,
  ReadTimeInfo,
  Overview,
} from './index.style';
import { Article as ArticleType } from '../../utils/schema';
import { articleUrl, eventTracking } from '../../utils';

const TopArticleCard = ({ article }: { article: ArticleType }) => {
  if (!article) {
    return null;
  }

  const {
    primaryImage,
    slug,
    title,
    category: { name: category, slug: categorySlug },
    author,
    published,
    formattedPublished,
    readTime,
    shortOverview,
  } = article;
  const categoryLink = `/?category=${categorySlug}`;
  const categoryLinkAs = `/inspire/category/${categorySlug}`;
  const articleLink = `/article?category=${categorySlug}&slug=${slug}`;
  const articleLinkAs = `/inspire/${categorySlug}/${slug}`;

  return (
    <Article itemScope itemType="http://schema.org/Article">
      <meta itemProp="datePublished" content={published} />
      <meta itemProp="url" content={articleUrl(article)} />
      <meta itemProp="mainEntityOfPage" content={articleUrl(article)} />
      <meta itemProp="name" content={title} />
      <meta itemProp="headline" content={title} />
      <Link as={articleLinkAs} href={articleLink} passHref>
        <FigureLink
          target="_blank"
          onClick={() => {
            eventTracking('above-fold', 'navigate', 'Primary Image (Desktop)');
          }}
        >
          <Figure style={{ backgroundImage: `url(${primaryImage})` }} />
        </FigureLink>
      </Link>
      <Summary>
        <Link as={categoryLinkAs} href={categoryLink} passHref>
          <CategoryLink
            target="_blank"
            onClick={() => {
              eventTracking('above-fold', 'navigate', category);
            }}
          >
            <Category>{category}</Category>
          </CategoryLink>
        </Link>
        <Link as={articleLinkAs} href={articleLink} passHref>
          <Alink
            target="_blank"
            onClick={() => {
              eventTracking('above-fold', 'navigate', title);
            }}
          >
            <Heading>{title}</Heading>
          </Alink>
        </Link>
        <BlogInfo>
          <AuthorInfo>
            By <Author itemProp="author">{author}</Author>,
          </AuthorInfo>
          <time dateTime={published} itemProp="datePublished">
            {formattedPublished}
          </time>
          <ReadTimeInfo>| {readTime} min read</ReadTimeInfo>
        </BlogInfo>
        <Overview>{shortOverview}</Overview>
      </Summary>
    </Article>
  );
};

export default TopArticleCard;
